'use client';

import React from 'react';
import Image from 'next/image';
import { motion } from 'framer-motion';
import SplitReveal from '@/components/motion/SplitReveal';
import Eyebrow from '@/components/ui/Eyebrow';

const reveal = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: [0.22, 1, 0.36, 1] } },
};

const TeamSection = () => {
  const teamMembers = [
    {
      name: 'Stephan Fiebelkorn',
      position: 'Founder & CEO',
      image: '/images/stephan.png',
    },
    {
      name: 'Craig Chasnov',
      position: 'CEO LenSync',
      image: '/images/craig.jpg',
    },
    {
      name: 'Dely',
      position: 'CEO ASIA',
      image: '/images/dely.jpg',
    },
    {
      name: 'Yardan',
      position: 'Software Engineer',
      image: '/images/yardan.jpg',
    },
  ];

  return (
    <section className="relative overflow-hidden py-24 sm:py-32">
      {/* ambient glow — brand blue + mint, no purple */}
      <div className="pointer-events-none absolute -left-24 top-16 size-72 rounded-full bg-primary-blue/10 blur-3xl" />
      <div className="pointer-events-none absolute -right-20 bottom-8 size-72 rounded-full bg-emerald-200/30 blur-3xl" />

      <div className="container relative mx-auto px-5">
        {/* intro */}
        <div className="mx-auto max-w-4xl text-center">
          <Eyebrow className="mb-5">Meet our team</Eyebrow>
          <SplitReveal className="display text-[clamp(34px,4.4vw,64px)] text-secondary-dark">
            Discover the People Behind Our Success
          </SplitReveal>
        </div>

        {/* team bento */}
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-80px' }}
          transition={{ staggerChildren: 0.08 }}
          className="mx-auto mt-14 grid max-w-6xl grid-cols-2 gap-x-4 gap-y-8 lg:grid-cols-4 lg:gap-x-6"
        >
          {teamMembers.map((member) => (
            <motion.div key={member.name} variants={reveal} className="group">
              <div className="relative overflow-hidden rounded-2xl bg-ink">
                <Image
                  src={member.image}
                  alt={member.name}
                  width={306}
                  height={349}
                  className="h-[260px] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04] sm:h-[340px]"
                />
              </div>
              <div className="mt-4 border-t border-secondary-dark/10 pt-3">
                <h3 className="text-lg font-semibold tracking-tight text-secondary-dark">
                  {member.name}
                </h3>
                <p className="label mt-1 text-[10px] text-primary-blue">{member.position}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TeamSection;
